import { render, staticRenderFns } from "./FinalizacaoIniciarReprovar.vue?vue&type=template&id=88fcae02"
import script from "./FinalizacaoIniciarReprovar.vue?vue&type=script&lang=js"
export * from "./FinalizacaoIniciarReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports